

import React from 'react';

import ReactDOM from 'react-dom';

import { Button, Tabs } from "@jd/find-react";


 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';
import FeasComponents from '../render/FeasComponents.js'


const { TabPane } = Tabs;

export default class FsTabs extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			randId: this.getRandString(),
			tabs: null,
			activeTab: '',
		}

	}

	componentWillMount() {
		 
		this.registComponent();
	}
	
	componentDidMount() {
		this.sendPageEvent("mounted");
	}

	componentDidUpdate(prevProps) {
		const { activeTab } = this.state;
		if(activeTab === '' && prevProps.component.cp.activeName) {
			this.setState({ activeTab: prevProps.component.cp.activeName })
		}
	//	console.log('prevProps', prevProps)
	}

	setTabs = (tabs, activeTab) => {
		this.state.tabs = tabs;
		if (activeTab === null) {
			this.state.activeTab = tabs[0].cp.name;
		}
		else {
			this.state.activeTab = activeTab;
		}
		this.refresh();
	}
	handleClick = (selectItem) => {
		
	//	alert("ddddd");
		
		this.props.component.cp.activeName = selectItem.cp.name;
		this.state.activeTab = selectItem.cp.name;
		if (this.debug === true) {
			this.sendEvent("clearSelectState");
			setTimeout(function () {
				this.sendEvent("selectComponent", selectItem);
			}, 20)
		}
		if (this.debug !== true) {
			this.sendPageEvent("select", this.props.component.cp.activeName);
		}
	}
	onCommand = (cmdName, item, po, thisForm, parentForm) => {
		this.$emit("command", cmdName, item, po, thisForm, parentForm);
	}
onChanged = (ret) => {
		this.$emit("changed", ret);
	}
	setActiveTab = (key) => {
		this.setState({ activeTab: key});
		this.sendPageEvent("select",key)
	};
	render() {
		const { activeTab } = this.state;
		if(this.state.tabs)
		{
			return (
			 
				<div className={`el-tabs`} style={{ 'minHeight': (this.props.debug === true ? '130px' : '5px') }} >
			
					<Tabs disabled onChange = {this.onChange} onTabClick={(key,event)=>{  this.sendPageEvent("select",key)}} >
						{
							  this.state.tabs.map((item, index) => {
								return <TabPane tab={item.cp.title} key={item.cp.name} disabled={this.props.po&&( this.props.po.handleItem || [].includes(item.cp.name))}>  </TabPane>
							})
						}
					</Tabs>
			
				</div>
			);
		}
		else
		{
			return (
				<div className={`el-tabs`} style={{ 'minHeight': (this.props.debug === true ? '130px' : '5px') }} >
			   
					<Tabs onChange = {this.onChange} activeKey={activeTab} onTabClick={(key,event)=>{ this.setActiveTab(key) }}  centered={this.props.component.cp.centered}  >
						{
							this.props.component.child && this.props.component.child.map((item, index) => {
								return <TabPane tab={item.cp.title} key={item.cp.name} forceRender={true}   disabled={this.props.po&&(this.props.po.handleItem || [].includes(item.cp.name))}> 
								<div boxid={item.id} tid={item.id}>
			
									<FeasComponents components={item.child} po={this.props.po}
									keePage={this.props.keePage} 
									 thisForm={this.props.thisForm} parentForm={this.props.parentForm} 
									 name={this.props.name} 
									 query={this.props.query} 
									 editable={this.props.editable} 
									 debug={this.props.debug} 
									 oncommand={this.onCommand}
									 onChanged = {this.onChanged}>
									</FeasComponents>
			
								</div>
								</TabPane>
							})
						}
					</Tabs>
			
				</div>
			);
		}
		
	}
}
